enum CampusType {
    MainCampus = 0,
    RegionalCampus = 1,
    Extension = 2,
    Somewhere = 3,
    OnlineCampus = 4,
}

export default CampusType;
